import { render, staticRenderFns } from "./RecommendEpisodeCard.vue?vue&type=template&id=7a2b8579"
import script from "./RecommendEpisodeCard.vue?vue&type=script&lang=js"
export * from "./RecommendEpisodeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports